"use client";
import { InteractiveBookingWidget } from "./interactive-widget";
import { SignupCtaButton } from "../signup-cta-button";
import { CheckCircle2Icon, StarIcon } from "lucide-react";


export function Hero() {
  return (
    <section className="relative pt-28 pb-12 md:pt-36 md:pb-16 min-h-[85vh] flex items-center">
      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-8 items-center">
          
          {/* Text Content - SEO & Conversion Focused */}
          <div className="flex flex-col items-start text-left gap-6 md:gap-7">
            
            {/* Trust Badge / SEO H2 Subtitle */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-md">
               <div className="flex gap-0.5">
                  {[1,2,3,4,5].map(i => <StarIcon key={i} className="size-3 text-yellow-500 fill-yellow-500" />)}
               </div>
               <span className="text-[10px] md:text-xs font-semibold text-white/80 uppercase tracking-wider">
                 O Sistema #1 para Salões e Estúdios
               </span>
            </div>

            {/* SEO Optimized H1 */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] font-black leading-[1.05] tracking-tighter text-white">
              Sistema de <br /> Agendamento Online <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-purple-400 to-primary/80">
                 que vende por você.
              </span>
            </h1>
            
            {/* Value Proposition */}
            <p className="text-base md:text-lg text-white/60 max-w-xl leading-relaxed font-medium">
              Pare de perder clientes no WhatsApp. Tenha sua própria página de agendamento 24h, reduza faltas com lembretes automáticos e organize sua agenda em um só lugar.
            </p>

            {/* Micro-benefits */}
            <div className="flex flex-wrap gap-x-4 gap-y-2 mt-2">
               {["Site pronto na hora", "Não exige cartão", "Cancele quando quiser"].map(benefit => (
                 <div key={benefit} className="flex items-center gap-1.5 text-xs md:text-sm text-white/70 font-medium">
                    <CheckCircle2Icon className="size-4 text-green-400" />
                    {benefit}
                 </div>
               ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto pt-4">
               <SignupCtaButton className="w-full sm:w-auto bg-white text-black hover:bg-white/90 shadow-[0_0_30px_rgba(255,255,255,0.2)] rounded-xl h-14 text-base px-8" />
               <a 
                 href="https://agendei.kayooliveira.com/goreteoliveira" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 className="flex items-center justify-center h-14 px-8 rounded-xl bg-white/5 border border-white/10 text-white font-bold hover:bg-white/10 transition-colors w-full sm:w-auto"
               >
                 Veja demonstração
               </a>
            </div>
          </div>

          {/* Interactive Widget Mockup */}
          <div className="relative w-full flex justify-center lg:justify-end mt-4 lg:mt-0">
            {/* Glow backing */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] bg-primary/20 blur-[100px] rounded-full mix-blend-screen pointer-events-none" />
            <div className="w-full max-w-[360px]">
               <InteractiveBookingWidget />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
